window.addEventListener("load", (event) => {
    $('body').on('click', '.buy-1-click-button', function (e) {
        if ($(this).parents('.buy-1-click').find('.del-char').val().length <= 12) {
            e.preventDefault();
            /* alert(`${t('number_format')}`);*/
            $('#liveToastPhone').removeClass('hide').addClass('show');

            setTimeout(function () {
                $('#liveToastPhone').removeClass('show').addClass('hide');
            }, 5000);
        }
    });

    $('#copyCode').click(function () {
        var text = $('#textToCopy').text();
        // Створюємо тимчасовий елемент textarea
        var tempElement = $('<textarea>');
        // Додаємо текст у тимчасовий елемент textarea
        tempElement.text(text);
        // Додаємо тимчасовий елемент до сторінки
        $('body').append(tempElement);
        // Вибираємо текст у тимчасовому елементі
        tempElement.select();
        // Копіюємо текст у буфер обміну
        document.execCommand('copy');
        // Видаляємо тимчасовий елемент textarea
        tempElement.remove();
    });
    if ($('#page-product').attr('data-is-outlet')){
        let priceElement = $('.priceElement').html();
        window.priceElement = priceElement;
        let btnSelectStore = $('.btnSelectStore').html();
        window.btnSelectStore = btnSelectStore;
        let storeIsSelected = false;
        let toModal = '0';
    }

    $('.buy-1-click, .one-click-mobile-form').submit(function (e) {
        e.preventDefault();
        console.log('show')
        $('#gotop').hide();
        let button = $(this).find('.buy-1-click-button');
        let message = $('#sticky-message-text');
        button.attr('disabled', 'true');
        $('.one-click-spiner').show();
        $.ajax({
            type: "POST",
            url: '/ajax/send_one_click',
            data: $(this).serialize(),
            beforeSend: function () {
                button.css('pointer-events', 'none')
            },
            success: function (data) {

                message.html(data.replace(/<\/?[^>]+(>|$)/g, ""));
                $('#sticky-message').toast('show').css('z-index','999')
                $('.one-click-spiner').hide();
                if ($('#modalOutletReserve').length){
                    $('#modalOutletReserve').modal('hide')
                    $('.form-input__phone').val('')
                    window.onloadCallback(1);
                    $('.priceElement').html(priceElement)
                    $('.btnSelectStore').html(btnSelectStore)
                    $('.selectStoreList').css('visibility','hidden')
                    $('.btnOutletReserve').attr('data-select','0')
                    $('.form-input__phone').css('border-color','red')
                    storeIsSelected = false;
                    toModal = '0';
                    $('.selectShop').each(function() {
                        $(this).removeClass('btn-orange-outline').addClass('btn-orange');
                    });
                    let data_new = JSON.parse(data);
                    let token = data_new.token;
                    $('.one-click-order input[name="temporary_token"]').val(token);
                }


                setTimeout(function () {
                    $('#sticky-message').toast('hide').css('z-index','2')
                    $(this).find('input').not(':input[type=submit], :input[type=hidden]').val('');
                    $('#gotop').show();
                }, 10000);
            },
            error: function (jqXHR, text, error) {

                message.html(error);
                message.show(300);
                setTimeout(function () {
                    message.hide(300);
                    message.html('');
                    $(this).find('input').not(':input[type=submit], :input[type=hidden]').val('');
                }, 5000);
                button.removeAttr('disabled');
            },
            complete: function () {
                button.removeAttr('disabled');
                button.removeAttr('style');
            }
        });
        return false;
    });

    if (window.innerWidth <= 600) {
        const product_id = parseInt($('.product-container-id').data('id'));
        e_view_item(product_id);

        $('.e_add_to_wished').on('click', function () {
            if (!$('.e_add_to_wished').hasClass('active')) {
                e_add_to_wishlist($(this).data('productid'));
            }
        })


        $('.stAddToCart').on('click', function () {
            let product = parseInt($(this).val());
            e_add_to_cart(1, product)
        });

        $('.clone-one-click').on('input paste', function () {
            let phone = $(this).val().replace(/[^+\d]/g, '');

            if (phone.substring(0, 3) !== '+38') {
                phone = '+38';
            }

            if (phone.substring(0, 4) !== '+380') {
                phone = '+380';
            }

            $('.clone-one-click').val(phone);

        });

        // $('.product-product-item').click(function (){
        //     let posProduct = $(this).first();
        // });

        // if ($(window).width() > 500) {
        //     $(".popov_next a").popover({
        //         trigger: 'hover',
        //         placement: 'auto',
        //         html: true,
        //         content: function () {
        //             return $('#popover_content_wrapper_next').html();
        //         },
        //     });
        //     $(".popov_prev a").popover({
        //         trigger: 'hover',
        //         placement: 'auto',
        //         html: true,
        //         content: function () {
        //             return $('#popover_content_wrapper_prev').html();
        //         },
        //     });
        // }

        (function () {
            const zeroLength = 2;
            const second = 1000,
                minute = second * 60,
                hour = minute * 60,
                day = hour * 24;

            function updateTime() {
                let today = new Date(),

                    hh = today.getHours(),
                    dd = today.getDate(),
                    mm = String(today.getMonth() + 1),
                    yyyy = today.getFullYear(),
                    dateEnd = $('#countdown').data('date-to-end');


                today = yyyy + "-" + dd + "-" + mm + "-" + hh;


                const countDown = new Date(dateEnd).getTime();
                const now = new Date().getTime(),
                    distance = countDown - now;
                let
                    days = String(Math.floor(distance / (day))),
                    hours = String(Math.floor((distance % (day)) / (hour))),
                    minutes = String(Math.floor((distance % (hour)) / (minute))),
                    seconds = String(Math.floor((distance % (minute)) / second));

                let elementDays = document.getElementById("days");
                if (elementDays) {
                    elementDays.innerText = days;
                }

                let elementHours = document.getElementById("hours");
                if (elementHours) {
                    elementHours.innerText = hours.padStart(zeroLength, '0')
                }

                let elementMinutes = document.getElementById("minutes");
                if (elementMinutes) {
                    elementMinutes.innerText = minutes.padStart(zeroLength, '0')
                }

                let elementSeconds = document.getElementById("seconds");
                if (elementSeconds) {
                    elementSeconds.innerText = seconds.padStart(zeroLength, '0');
                }

            };
            updateTime();
            x = setInterval(function () {
                updateTime()
            }, 1000)

        }());

        $('.review-count').click(() => {
            $('base').remove();
            $('#reviews-tab').click();
        });

        window.addEventListener('onBitrixLiveChat', function (event) {
            var widget = event.detail.widget;
            if ($('.buy-1-click-sticky.d-flex').length > 0) {
                $('.b24-widget-button-wrapper').addClass('d-none');
            }

        });

        $('#billingPhone').on('keyup paste', function () {
            let phone = $(this).val().replace(/[^+\d]/g, '');

            if (phone.substring(0, 3) !== '+38') {
                phone = '+38';
            }

            if (phone.substring(0, 4) !== '+380') {
                phone = '+380';
            }

            $('#billingPhone').val(phone);
        });

        $("#validateCode").on('click', function (e) {
            e.preventDefault();
            let code = $("#first").val() + $("#second").val() + $("#third").val() + $("#fourth").val();
            let phone = $("#billingPhone").val();
            $(this).prop('disabled', true);

            $.post('/ajax/phone_verify_post', {'phone': phone, 'code': code}, function (isverified) {
                if (isverified === 1) {
                    $("#successVerief").removeClass('d-none');
                    console.log(isverified);

                    $('.buy-1-click').submit();
                } else {
                    $("#failureVerief").removeClass('d-none');
                }
            });

            setTimeout(function () {
                $("#modalVerifyPhoneCell").modal('hide');
            }, 2500);
        });

        document.addEventListener("DOMContentLoaded", function (event) {
            function OTPInput() {
                const inputs = document.querySelectorAll('#otp > *[id]');
                for (let i = 0; i < inputs.length; i++) {
                    inputs[i].addEventListener('keydown', function (event) {
                        if (event.key === "Backspace") {
                            inputs[i].value = '';
                            if (i !== 0) inputs[i - 1].focus();
                        } else {
                            if (i === inputs.length - 1 && inputs[i].value !== '') {
                                return true;
                            } else if ((event.keyCode > 47 && event.keyCode < 58) || (event.keyCode > 95 && event.keyCode < 106)) {
                                inputs[i].value = event.key;
                                if (i !== inputs.length - 1) inputs[i + 1].focus();
                                event.preventDefault();
                            } else if (event.keyCode > 64 && event.keyCode < 91) {
                                inputs[i].value = String.fromCharCode(event.keyCode);
                                if (i !== inputs.length - 1) inputs[i + 1].focus();
                                event.preventDefault();
                            }
                        }
                    });
                }
            }

            OTPInput();
        });

    } else {

        const product_id = parseInt($('.product-container-id').data('id'));
        e_view_item(product_id);
        $('.e_add_to_wished').on('click', function () {
            if (!$('.e_add_to_wished').hasClass('active')) {
                e_add_to_wishlist($(this).data('productid'));
            }
        })

        $('#single_add_to_cart_button').on('click', function () {
            let inCart = $(this).data('incart');
            let product = parseInt($(this).val());
            if (inCart == 0) {
                if ($('#result_count').text() != '0') {
                    e_add_to_cart($('#result_count').text(), product);
                } else {
                    e_add_to_cart(1, product)
                }
            }
        });

        $('#modalCartDataWrap').on('click', '.btn-to-checkout', function () {
            e_begin_checkout();
        });

        $(function () {
            $('.lSNext').html('<i class="leo-icon leo-arrow-right-dbl s-30"></i>');
            $('.lSPrev').html('<i class="leo-icon leo-arrow-left-dbl s-30"></i>');
            $(".form-input__phone").mask("+38-(099)-999-99-99", {placeholder: " "});
        });

        (function () {
            const zeroLength = 2;
            const second = 1000,
                minute = second * 60,
                hour = minute * 60,
                day = hour * 24;

            function updateTime() {
                let today = new Date(),

                    hh = today.getHours(),
                    dd = today.getDate(),
                    mm = String(today.getMonth() + 1),
                    yyyy = today.getFullYear(),
                    dateEnd = $('#countdown').data('date-to-end');


                today = yyyy + "-" + dd + "-" + mm + "-" + hh;


                const countDown = new Date(dateEnd).getTime();
                const now = new Date().getTime(),
                    distance = countDown - now;
                let
                    days = String(Math.floor(distance / (day))),
                    hours = String(Math.floor((distance % (day)) / (hour))),
                    minutes = String(Math.floor((distance % (hour)) / (minute))),
                    seconds = String(Math.floor((distance % (minute)) / second));

                let elementDays = document.getElementById("days");
                if (elementDays) {
                    elementDays.innerText = days;
                }

                let elementHours = document.getElementById("hours");
                if (elementHours) {
                    elementHours.innerText = hours.padStart(zeroLength, '0')
                }

                let elementMinutes = document.getElementById("minutes");
                if (elementMinutes) {
                    elementMinutes.innerText = minutes.padStart(zeroLength, '0')
                }

                let elementSeconds = document.getElementById("seconds");
                if (elementSeconds) {
                    elementSeconds.innerText = seconds.padStart(zeroLength, '0');
                }

            };
            updateTime();
            x = setInterval(function () {
                updateTime()
            }, 1000)

        }());

        if ($(window).width() > 500) {
            // popover next product
            $(".popov_next a").popover({
                trigger: 'manual',
                placement: 'top',
                container: 'body',
                html: true,
                offset: '0, 20',
                content: function () {
                    return $('#popover_content_wrapper_next').html();
                },
            }).on('mouseenter', function () {
                showPopover('.popov_next a');
            }).parent().on('mouseleave', function () {
                hidePopover('.popov_next a');
            });

            // popover previous product
            $(".popov_prev a").popover({
                trigger: 'manual',
                placement: 'top',
                container: 'body',
                html: true,
                offset: '0, 20',
                content: function () {
                    return $('#popover_content_wrapper_prev').html();
                },
            }).on('mouseenter', function () {
                showPopover('.popov_prev a');
            }).parent().on('mouseleave', function () {
                hidePopover('.popov_prev a');
            });

            // close popover when cursor leave him
            $(document).on('mouseleave','.popover',function() {
                $(this).popover('hide');
            });

            // function smoothly show popover
            function showPopover(element) {
                setTimeout(function () {
                    if ($('.popover:hover').length === 0) {
                        $(element).popover('show');
                    }
                }, 100);
            }

            // function smoothly hide popover
            function hidePopover(element) {
                setTimeout(function () {
                    if ($('.popover:hover').length === 0) {
                        $(element).popover('hide');
                    }
                }, 100);
            }
        }

        // if ($(window).width() > 500) {
        //     $(".popov_next a").popover({
        //         trigger: 'hover',
        //         placement: 'top',
        //         container: 'body',
        //         html: true,
        //         content: function () {
        //             return $('#popover_content_wrapper_next').html();
        //         },
        //     });
        //     $(".popov_prev a").popover({
        //         trigger: 'hover',
        //         placement: 'top',
        //         container: 'body',
        //         html: true,
        //         content: function () {
        //             return $('#popover_content_wrapper_prev').html();
        //         },
        //     });
        // }

        $('.review-count').click(() => {
            $('base').remove();
            $('#reviews-tab').click();
        });

        $('.product-full-description a[href^="https://leoceramika.com/product/"]').hover(function () {
                let that = this;
                $.ajax({
                    type: 'POST',
                    data: {url: $(this).attr('href')},
                    url: '/ajax/get_page_data_by_url',
                    success: function (product) {
                        let wished = (getCookie('wishlist') && getCookie('wishlist').includes('|' + product.id + '|')) ? true : false;
                        let hasRu = location.href.match(/(^https?:\/\/.+\/ru\/.+)|(^https?:\/\/.+\/ru\/?$)/gim);
                        let uriPrepender = hasRu !== null ? '/ru/' : '/';
                        let obj = JSON.parse(product.filters);

                        console.log('returned filters: ', obj);
                        let countryName = (obj && `Країна походження` in obj) ? obj['Країна походження'].split('|')[0] :
                            (obj && `Страна происхождения` in obj) ? obj['Страна происхождения'].split('|')[0] : '';
                        let countrySlug = (obj && 'Країна походження' in obj) ? obj['Країна походження'].split('|')[1] :
                            (obj && 'Страна происхождения' in obj) ? obj['Страна происхождения'].split('|')[1] : '';
                        let brandName = (obj && 'Бренд' in obj) ? obj['Бренд'].split('|')[0] : '';
                        let brandSlug = (obj && 'Бренд' in obj) ? obj['Бренд'].split('|')[1] : '';
                        let collectionName = (obj && 'Колекція' in obj) ? obj['Колекція'].split('|')[0] :
                            (obj && 'Коллекция' in obj) ? obj['Коллекция'].split('|')[0] : '';
                        let collectionSlug = (obj && 'Колекція' in obj) ? obj['Колекція'].split('|')[1] :
                            (obj && 'Коллекция' in obj) ? obj['Коллекция'].split('|')[1] : '';

                        let template = `<div class="col col-sm-6 col-md-4 col-lg-12 product-wrap product-interior">
										<div class="product">
											<div class="row row-no-gutters">
												<a class="col-5 product-img" href="${product.uri}" target="_blank">
													<img loading="lazy" src="${product.logo}" alt="${product.name}" title="${product.name}">
												</a>
												<div class="col-7 product-body">
													<a href="${product.uri}" target="_blank">
														<div class="product-title" title="${product.name}">
														${product.name.length > 50 ? product.name.substr(0, 50) + '…' : product.name}
														</div>
													</a>
													<div class="price-box">
														${product.price_total}
														<span class="price-currency">грн/${product.unit}</span>
													</div>
													<form class="form-add-to-cart" data-productid="${product.id}">
														<input type="hidden" name="Ref_Key" value="${product.Ref_Key}">
														<input type="hidden" name="price" value="${product.site_price}">
														<input type="hidden" name="name" value="${product.name}">
														<input type="hidden" name="logo" value="assets.leoceramika.com/img/${product.logo}">
														<input type="hidden" name="id" value="${product.id}">
														<input type="hidden" name="count" value="${product.in_box ? product.in_box : '1'}">
														<input type="hidden" name="max_count" value="99999999">
														<input type="hidden" name="cat_name" value="${product.cat_name ?? ''}">
														<button class="btn btn-sm btn-orange" title="${t('buy')}"><i class="fas fa-shopping-cart"></i></button>
														<a href="${product.uri}" target="_blank" class="btn btn-sm btn-orange" title="${t('review')}"><i class="fas fa-eye"></i></a>
														<button type="button" class="btn btn-sm btn-orange postpone-link ${wished ? ' active' : ''}" title="${wished ? t('wished') : t('postpone')}" data-productid="${product.id}">
															<i class="${wished ? 'fas' : 'far'} fa-heart color-orange"></i>
														</button>
													</form>
												</div>
											</div>
											<div class="row row-no-gutters">
												<div class="product-detail d-block mb-0 mt-2">
													<table>
														<tbody>
															<tr>
																<td>${t('producing_country')}</td>
																<td>
																	<a href="${uriPrepender}catalog/${product.cat_url}_${product.cat_id}/kraina-pokhodzhennia:${countrySlug}">${countryName}</a>
																</td>
															</tr>
															<tr>
																<td>Фабрика:</td>
																<td>
																	<a href="${uriPrepender}catalog/${product.cat_url}_${product.cat_id}/brend:${brandSlug}">${brandName}</a>
																</td>
															</tr>
															<tr>
																<td>${t('collection')}</td>
																<td>
																	<a href="${uriPrepender}catalog/${product.cat_url}_${product.cat_id}/kolektsiia:${collectionSlug}">${collectionName}</a>
																</td>
															</tr>
															<tr>
																<td>Артикул:</td>
																<td>${product.Артикул}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>`;
                        if (!$(that).hasClass('initialized')) {
                            $(that).popover({
                                trigger: 'manual',
                                template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body p-0"></div></div>',
                                placement: 'auto',
                                html: true,
                                content: template,
                            });
                            $(that).addClass('initialized');
                        }
                        $('.product-full-description a[href^="https://leoceramika.com/product/"]').popover('hide');
                        $(that).popover('show');
                        $('.popover').on('mouseleave', function () {
                            $(that).popover('hide');
                        });
                    }
                });
            },
            function () {
                setTimeout(() => {
                    if (!$('.popover:hover').length) {
                        $(this).popover('hide');
                    }
                }, 300);
            });

        $('#upsells-products').lightSlider({
            item: 4,
            loop: true,
            slideMove: 1,
            speed: 600,
            slideMargin: 0,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        item: 4,
                        slideMove: 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        item: 3,
                        slideMove: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        item: 2,
                        slideMove: 1
                    }
                },
                {
                    breakpoint: 420,
                    settings: {
                        item: 1,
                        slideMove: 1
                    }
                }
            ]
        });

        // $('img[data-enlargable]').click(function () {
        //     const src = $(this).attr('data-origin-src');
        //
        //     let overlay = $('<div>').css({
        //         background: 'RGBA(0,0,0,.5) url(' + src + ') no-repeat center',
        //         backgroundSize: 'auto',
        //         width: '100%',
        //         height: '100%',
        //         maxWidth: '100%',
        //         maxHeight: '100%',
        //         position: 'fixed',
        //         zIndex: '10000',
        //         top: '0',
        //         left: '0',
        //
        //         cursor: 'zoom-out',
        //     }).click(function () {
        //         $(this).remove();
        //     }).appendTo('body');
        //     let closeButton = $('<div>').html('x').addClass('close_zoom_btn').click(function () {
        //         overlay.remove();
        //     }).appendTo(overlay);
        // });

        $('img[data-enlargable]').click(function () {
            const src = $(this).attr('data-origin-src');

            let overlay = $('<div>').css({
                background: 'rgba(0,0,0,0.5)',
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                position: 'fixed',
                zIndex: '10000',
                top: '0',
                left: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'zoom-out'
            }).click(function () {
                $(this).remove();
            }).appendTo('body');

            let img = $('<img>').attr('src', src).css({
                maxWidth: '100%',
                maxHeight: '90%',
                display: 'block'
            }).appendTo(overlay);

            let closeButton = $('<div>').html('x').addClass('close_zoom_btn').css({
                position: 'absolute',
                top: '10px',
                right: '10px',
                fontSize: '24px',
                color: 'white',
                cursor: 'pointer'
            }).click(function () {
                overlay.remove();
            }).appendTo(overlay);
        });

        $('.know_discount').on('click', function () {
            $('#modalShowDiscount').modal();
            const phone = $('#phone');
            phone.val('+380');

            phone.on('input', function () {
                let inputValue = $(this).val();
                let numericValue = inputValue.replace(/\D/g, '');
                let sanitizedValue = numericValue.startsWith('380') ? '+' + numericValue : '+380' + numericValue;

                sanitizedValue = sanitizedValue.substring(0, 13);
                $(this).val(sanitizedValue);
            });

            phone.on('keydown', function (e) {
                const key = e.keyCode || e.charCode;
                const cursorPosition = this.selectionStart;

                if ($(this).val() === '+380' && (key === 8 || key === 46)) {
                    e.preventDefault();
                    return;
                }

                if ((key === 8 || key === 46) && cursorPosition >= 4) {
                    return;
                }

                let inputValue = $(this).val().replace(/\D/g, '');
                let sanitizedValue = inputValue;

                if (!sanitizedValue.startsWith('380')) {
                    sanitizedValue = '380' + sanitizedValue;
                }

                sanitizedValue = sanitizedValue.substring(0, 13);
                $(this).val(sanitizedValue);
            });

            $('#know_discount_form').on('submit', function (e) {
                e.preventDefault();
                const toast = $('#know_discount_toast');
                const data = $(this).serializeArray();
                const sendButton = $('.know_discount_button');
                const spinner = $('.know-discount-spinner');

                if (phone.val().length === 13) {
                    $.ajax({
                        type: "POST",
                        url: '/ajax/send_wish_discount',
                        data: data,
                        beforeSend: function () {
                            spinner.removeClass('d-none');
                            sendButton.prop('disabled', true)
                        },
                        success: function (data) {
                            phone.removeClass('border-danger');
                            $('#showDiscountPhoneError').addClass('d-none');
                            $('#modalShowDiscount').modal('hide');
                            toast.find('.toast-body').html(data);
                            toast.toast('show');
                        },
                        complete: function () {
                            spinner.addClass('d-none');
                            sendButton.prop('disabled', false)
                        }
                    });
                } else {
                    phone.addClass('border-danger');
                    $('#showDiscountPhoneError').removeClass('d-none');
                }
            });
        });

    }
})